export const SELECTED_APPLICATION_LOG_INDEX = "selectedApplicationLogIndex"
export const APPLICATION_LOG_DETAILS = "applicationLogDetails"
export const LOG_SUMMARY_PARAMS = "logSummaryParam"